/**
* npm install firebase-functions
* firebase login
* firebase login:add
* firebase login:list
* firebase login:use emilio.malaman@bairesdev.com
* firebase projects:list
* firebase use storelocatorapi-58f43
* firebase deploy --only hosting:storelocatorapi-58f43
* firebase serve
*/

<template>

  <div class="ui computer reversed stackable grid">
    <div id="map-container" class="sixteen wide tablet ten wide computer column" ref="map"></div>
    <div class="sixteen wide tablet six wide computer column">

      <div class="tab-menu">
        <button
          v-for="(tab, index) in tabs"
          :key="index"
          :class="{ active: activeTab === index }"
          @click="changeTab(index)"
        >
          {{ tab.label }}
        </button>
      </div>

      <div class="tab-content">
        <div v-for="(tab, index) in tabs" :key="index" v-show="activeTab === index">
          <form class="ui form" v-if="tab.formType === 'form1'" @submit.prevent="submitForm1">
            <!-- Simple Search -->
            <div class="ui middle aligned grid" :class="{loading:spinner}">
              <div class="sixteen wide column">
                <div class="ui message red" v-show="error">{{error}}</div>
                <div class="field">
                  <label>Type an address and click "Search" (or hit Enter)</label>
                  <input type="text" placeholder="Type here your address"
                    v-model="address"
                    id="autocomplete"
                    />
                </div>
                <button class="fluid ui button" @click="onEnter($event,address)">Search</button>
              </div>
            </div>
          </form>

          <form class="ui form" v-else-if="tab.formType === 'form2'" @submit.prevent="submitForm2">
            <!-- Advanced Search  -->
            <div class="ui middle aligned grid">
              <div class="sixteen wide column" v-show="showInput">

                <div class="two fields">
                  <div class="field">
                    <label>Store type</label>
                    <select name="type" v-model="newChoice.type">
                      <option value="All" selected = "true">Any</option>
                      <option value="Bar/Restaurant">Bar/Restaurant</option>
                      <option value="Liquor Store">Liquor Store</option>
                    </select>
                  </div>
                  <div class="field">
                    <label>Country</label>
                      <select v-model="country.type" @change="clearStates" >
                        <option value="USA" selected = "true">United States</option>
                      </select>
                  </div>
                </div>

                <div class="two fields" v-if="country.type === 'USA'">
                    <div class="field">
                      <label>State</label>
                      <select id="state" v-model="selectedState" @change="getCities" >
                        <option value="">All states</option>
                        <option v-for="state in states" :key="state" :value="state">{{ state }}</option>
                      </select>
                    </div>
                    <div class="field">
                      <label>City</label>
                      <select id="city" v-model="selectedCity">
                        <option value="">Select a city</option>
                        <option v-for="city in cities" :key="city" :value="city">{{ city }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="ui middle aligned grid">
                    <div class="sixteen wide column">
                      <button class="ui fluid small button" @click="findCloseBuyButtonPressed(newChoice.type,selectedState,selectedCity,country.type,$event)" >Search</button>
                    </div>
                  </div>

              </div>



            </div>

          </form>
        </div>
      </div>

      <div id="result-title">
        <p>Results (click to find on the map)</p>
      </div>

      <div id="store-list" class="ui segment">
        <div class="ui relaxed divided list">
          <div class="item" v-for="(place,index) in places"
          :key="place.id"
          @click="showInfoWindow(index)"
          :class="{'active' : activeIndex === index}"
          style = "padding:10px;"
          >
            <div class="content">
              <div class="header">{{ place.name }}</div>
              <div class="description">{{place.address}}</div>
              <div class="description">{{place.city}}-{{place.state}}</div>
              <div class="description" v-if="place.website !== 'undefined' && place.website !== ''">
                <a
                class="description-link"
                :href="place.website"
                target="_blank"
                style="font-size: 16px; color: rgb(36, 194, 208);"
                @click="logClickedWebsite(place.website)"
              >Website</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="map-caption">
        <span class="caption-color" style="background-color:#00594e;">&nbsp;</span><small>Bar/Restaurant</small>
        <span class="caption-color" style="background-color:#bc955c;">&nbsp;</span><small>Liquor Store</small>
      </div>

      <div id="availability-alert">
        <small>Product availability not guaranteed. Please contact the store to confirm Mijenta products are in stock.</small>
      </div>

    </div>
  </div>
</template>
<script>
  import axios from  'axios';

  export default {
    data() {
      return {
        eventsLog: [],
        icon: [],
        stores: [],
        activeTab: 0,
        tabs: [
          { label: "Quick Search", formType: "form1" },
          { label: "Advanced Search", formType: "form2" },
        ],
        csvstores: [],
        showInput: true,
        address: "",
        error:"",
        spinner:false,
        //DEV apiKey: "AIzaSyB-XIaH9Sl8ofG1l5LcVf6c1ulwdwV4zWU",
        apiKey: "AIzaSyD2qmG6rcafkd9LORZYhyr6UZQ6ZN_lQyk",
        lat:0,
        lng:0,
        type:'',
        radius:'',
        places:[],
        markers:[],
        activeIndex: -1,
        stores: window.product,
        newChoice: {
          type: 'All'
        },
        selectedType: [],
        selectedType2: [],
        country:  {
          type: 'USA'
        },
        city:'',
        state:'',
        storeType:'',
        csvData: [],
        selectedState: '',
        selectedCity: '',
          states: ['AZ','CA','CO','CT','DC','DE','FL','GA','IL','IN','KS','KY','LA','MA','MD','MN','MO','NJ','NM','NV','NY','OK','SC','TX','WA','WI'],
          cityData: {
            'AZ': ['Bullhead City','Carefree','Chandler','Chino Valley','Cottonwood','Fort Mohave','Gilbert','Glendale','Gold Canyon','Goodyear','Lake Havasu City','Mesa','Oro Valley','Paradise Valley','Phoenix','Prescott','Queen Creek','Scottsdale','Sedona','Show Low','Surprise','Tempe','Tubac','Tucson','Yuma'],
            'CA': ['Alameda','Amador City','Anaheim','Apple Valley','Aptos','Atwater','Azusa','Bakersfield','Berkeley','Beverly Hills','Big Bear Lake','Brea','Buellton','Burbank','Burlingame','Calabasas','Calistoga','Camarillo','Campbell','Carlsbad','Carmel','Carmel By The Sea','Chula Vista','Clovis','Colton','Concord','Corona','Corona Del Mar','Costa Mesa','Culver City','Cypress','Daly City','Dana Point','Danville','Davis','Del Mar','El Segundo','Elk Grove','Encinitas','Escondido','Fair Oaks','Fairfield','Folsom','Foothill Ranch','Fremont','Fresno','Fullerton','Galt','Glendale','Granite Bay','Grass Valley','Greenbrae','Grover Beach','Healdsburg','Hercules','Hesperia','Highland','Hollister','Huntington Beach','Imperial Beach','Indio','Irvine','Kingsburg','La Canada Flintridge','La Crescenta','La Habra','La Jolla','La Puente','La Quinta','Lafayette','Laguna Beach','Laguna Hills','Laguna Niguel','Lake Forest','Lake Isabella','Livermore','Lodi','Lompoc','Long Beach','Los Altos','Los Angeles','Los Gatos','Malibu','Mammoth Lakes','Manhattan Beach','Marina','Marina Del Rey','Meadow Vista','Merced','Mill Valley','Mira Loma','Modesto','Monrovia','Monterey','Moorpark','Mountain View','Napa','National City','Nevada City','Newport Beach','Newport Coast','North Hollywood','Northridge','Novato','Oakland','Oceanside','Ojai','Orland','Oxnard','Pacific Grove','Pacific Palisades','Palm Desert','Palm Springs','Pasadena','Paso Robles','Patterson','Petaluma','Pico Rivera','Pinon Hills','Placentia','Playa Vista','Pleasant Hill','Pleasanton','Pomona','Port Hueneme','Porter Ranch','Rancho Cordova','Rancho Cucamonga','Rancho Mirage','Rancho Santa Fe','Redondo Beach','Redwood City','Richmond','Riverside','Rocklin','Roseville','Sacramento','Saint Helena','Salinas','San Anselmo','San Carlos','San Clemente','San Diego','San Dimas','San Francisco','San Gabriel','San Jose','San Juan Bautista','San Juan Capistrano','San Leandro','San Luis Obispo','San Marcos','San Mateo','San Pedro','San Rafael','San Ramon','Santa Ana','Santa Barbara','Santa Clara','Santa Cruz','Santa Maria','Santa Monica','Santa Rosa','Santa Ynez','Sausalito','Scotts Valley','Seal Beach','Seaside','Sherman Oaks','Signal Hill','Solana Beach','Solvang','Soquel','South El Monte','South Lake Tahoe','South San Francisco','Stevenson Ranch','Stockton','Sunnyvale','Tarzana','Temecula','Thousand Oaks','Torrance','Tracy','Truckee','Turlock','Tustin','Union City','Upland','Valencia','Vallejo','Valley Village','Van Nuys','Venice','Ventura','Victorville','Visalia','Walnut','Walnut Creek','West Covina','West Hollywood','West Sacramento','Westlake Village','Whittier','Winchester','Winnetka','Woodbridge','Woodland'],
            'CO': ['Arvada','Aspen','Aurora','Avon','Basalt','Boulder','Breckenridge','Brighton','Broomfield','Buena Vista','Carbondale','Castle Rock','Clifton','Colorado Springs','Crested Butte','Denver','Dillon','Durango','Edwards','Englewood','Evans','Evergreen','Fort Collins','Golden','Grand Junction','Lafayette','Lakewood','Leadville','Littleton','Lone Tree','Longmont','Louisville','Loveland','Milliken','Montrose','Parker','Pueblo','Rifle','Silverthorne','Steamboat Springs','Thornton','Timnath','Vail','Wellington','Westminster','Wheat Ridge','Windsor','Winter Park'],
            'CT': ['Avon','Bantam','Berlin','Bethel','Branford','Canterbury','Chester','Cromwell','Danbury','Darien','East Granby','East Haddam','East Hartford','East Lyme','East Windsor','Ellington','Fairfield','Farmington','Glastonbury','Haddam','Hamden','Hartford','Madison','Manchester','Mashantucket','Meriden','Middletown','Milford','Monroe','Moodus','Morris','Mystic','Naugatuck','New Fairfield','New Haven','New London','Newington','North Franklin','North Stonington','Norwalk','Norwich','Oakville','Old Saybrook','Orange','Pawcatuck','Riverside','Sandy Hook','Sharon','Simsbury','South Glastonbury','Stafford Springs','Stamford','Stonington','Stratford','Torrington','Uncasville','Vernon Rockville','Voluntown','Washington','Watertown','West Hartford','Westport','Winsted'],
            'DC': [' Washington'],
            'DE': ['Cheswold','Claymont','Dover','Lewes','Middletown','Millville','Ocean View','Rehoboth Beach','Wilmington'],
            'FL': ['Altamonte Springs','Boca Raton','Boynton Beach','Bradenton','Brandon','Campbellton','Cape Canaveral','Cape Coral','Clearwater','Cocoa','Coral Springs','Davie','Daytona Beach','Deerfield Beach','Delray Beach','Estero','Fort Lauderdale','Fort Myers','Gainesville','Hialeah','Hollywood','Homestead','Jacksonville','Jacksonville Beach','Jensen Beach','Jupiter','Key Biscayne','Key West','Kissimmee','Lady Lake','Lake Worth','Lakeland','Lithia','Lutz','Maitland','Melbourne','Miami','Miami Beach','Naples','Neptune Beach','North Miami Beach','North Palm Beach','Orlando','Palm Beach Gardens','Palm City','Palm Harbor','Panama City Beach','Pensacola','Placida','Plantation','Pompano Beach','Ponte Vedra Beach','Port Charlotte','Saint Augustine','Saint James City','Saint Petersburg','Sarasota','Seminole','Stuart','Tallahassee','Tampa','Tarpon Springs','Venice','Wellington','West Palm Beach','Winter Garden','Winter Park'],
            'GA': ['Adairsville','Adel','Albany','Alpharetta','Athens','Atlanta','Augusta','Avondale Estates','Blackshear','Blue Ridge','Braselton','Buford','Carrollton','Cartersville','Clayton','Columbus','Commerce','Conyers','Cordele','Cumming','Dacula','Dahlonega','Decatur','Douglas','Douglasville','Duluth','Elberton','Ellijay','Eton','Evans','Fairburn','Fitzgerald','Flowery Branch','Forest Park','Gainesville','Grayson','Greensboro','Grovetown','Hampton','Hazlehurst','Helen','Homerville','Jonesboro','Kennesaw','Lagrange','Lakeland','Lawrenceville','Lilburn','Lithia Springs','Locust Grove','Macon','Madison','Marietta','Morrow','Moultrie','Norcross','Powder Springs','Riverdale','Rome','Roswell','Savannah','Smyrna','Stockbridge','Stone Mountain','Suwanee','Thomasville','Tifton','Tucker','Union City','Valdosta','Warner Robins','Watkinsville','Woodstock'],
            'IL': ['Algonquin','Alton','Arlington Heights','Bannockburn','Barrington','Batavia','Benton','Berwyn','Bloomingdale','Bloomington','Blue Island','Bolingbrook','Buffalo Grove','Byron','Carbondale','Champaign','Chicago','Cicero','Crystal Lake','Decatur','Des Plaines','Downers Grove','Dundee','Elgin','Elmwood Park','Evanston','Evergreen Park','Fox Lake','Frankfort','Geneva','Glen Ellyn','Glencoe','Glendale Heights','Glenwood','Gurnee','Harvey','Highland Park','Highwood','Hoffman Estates','Homewood','Hoopeston','Joliet','Lake Bluff','Lake In The Hills','Lake Zurich','Lansing','Libertyville','Lincolnwood','Lisle','Lockport','Mchenry','Metropolis','Mokena','Montgomery','Mount Prospect','Naperville','New Lenox','Niles','North Aurora','Northbrook','Oak Brook','Oak Forest','Oak Lawn','Orland Park','Ottawa','Palatine','Park Ridge','Peoria','Peru','Plainfield','River Grove','Riverside','Rock Island','Rockford','Romeoville','Sandwich','Schaumburg','Schiller Park','Silvis','Skokie','Springfield','Vernon Hills','Waterloo','Westchester','Western Springs','Westmont','Wheeling','Willowbrook','Winnetka','Yorkville','Zion'],
            'IN': ['Bloomington','Carmel','Indianapolis','Kokomo','Merrillville','Mishawaka','Valparaiso'],
            'KS': ['Bonner Springs','Gardner','Great Bend','Hays','Haysville','Kansas City','Lansing','Larned','Lawrence','Leawood','Lenexa','Manhattan','Newton','Olathe','Overland Park','Paola','Prairie Village','Russell','Salina','Shawnee','Tonganoxie','Topeka','Wichita','Winfield'],
            'KY': ['Ashland','Bardstown','Beattyville','Bellevue','Clay City','Corbin','Danville','Elizabethtown','Fort Thomas','Fulton','Harlan','Hebron','Jackson','Lexington','London','Louisville','Monticello','Mount Sterling','Nicholasville','Paducah','Pikeville','Radcliff','Richmond','Shelbyville','Somerset','Williamsburg'],
            'LA': ['Alexandria','Lafayette','Mandeville','Metairie','New Orleans','Prairieville','Shreveport'],
            'MA': ['Allston','Attleboro','Belmont','Boston','Braintree','Brookline','Burlington','Cambridge','Canton','Cohasset','Danvers','Dedham','East Boston','Edgartown','Everett','Franklin','Gloucester','Great Barrington','Hyde Park','Jamaica Plain','Lexington','Longmeadow','Marblehead','Nantucket','Natick','Needham','Needham Heights','Newtonville','North Andover','North Attleboro','Northampton','Oak Bluffs','Plymouth','Reading','Revere','Roslindale','Shrewsbury','Somerville','South Boston','Sturbridge','Waltham','Watertown','West Roxbury','Westport', 'Winthrop','Woods Hole','Worcester'],
            'MD': ['Aberdeen','Abingdon','Annapolis','Arnold','Baltimore','Bel Air','Beltsville','Bowie','Brentwood','Catonsville','Chester','Chestertown','Cockeysville','College Park','Crownsville','Dundalk','Elkridge','Elkton','Ellicott City','Forest Hill','Frederick','Hanover','La Plata','Lanham','Laurel','Lusby','Lutherville Timonium','Mount Airy','Nottingham','Ocean City','Odenton','Owings Mills','Pikesville','Riverdale','Rosedale','Severna Park','Stevenson','Sykesville','Waldorf','White Plains','Woodstock'],
            'MN': ['Albertville','Andover','Austin','Bemidji','Byron','Chisholm','Cloquet','Crosby','Delano','Duluth','Elk River',',Faribault',',Hugo','Lakeville','Little Falls','Minneapolis','Monticello','Northfield','Osseo','Owatonna','Pipestone','Prior Lake','Rochester','Saint Michael','Saint Paul','Sartell','Sauk Rapids','Schroeder','Stillwater','Wayzata','Winona','Woodbury'],
            'MO': ['Ballwin','Bridgeton','Cardwell','Chesterfield','Columbia','Crystal City','Florissant','Grover','Imperial','O Fallon','Poplar Bluff','Saint Albans','Saint Ann','Saint Charles','Saint Louis','Saint Peters','Troy','Wentzville'],
            'NJ': ['Absecon','Asbury Park','Atlantic City','Avalon','Basking Ridge','Bayonne','Beach Haven','Belleville','Belvidere','Berkeley Heights','Beverly','Bloomingdale','Boonton','Bound Brook','Brick','Burlington','Caldwell','Cape May','Cedar Knolls','Chatham','Cherry Hill','Chester','Clarksboro','Clayton','Clifton','Colonia','Denville','Deptford','Dumont','East Rutherford','Eatontown','Edgewater','Edison','Egg Harbor Township','Elizabeth','Englishtown','Fair Lawn','Fanwood','Flanders','Flemington','Fort Lee','Franklin Park','Freehold','Garwood','Glen Ridge','Glen Rock','Hackensack','Hackettstown','Hainesport','Haledon','Haskell','Hawthorne','Hewitt','Hightstown','Hillsborough','Hillsdale','Ho Ho Kus','Hoboken','Holmdel','Jersey City','Kearny','Lakewood','Lincoln Park','Lincroft','Little Falls','Little Ferry','Livingston','Lodi','Long Branch','Lyndhurst','Madison','Manahawkin','Manasquan','Maplewood','Marlboro','Marlton','Marmora','Matawan','Mays Landing','Medford','Mendham','Merchantville','Metuchen','Middletown','Millburn','Monmouth Junction','Monroe Township','Montclair','Montvale','Morganville','Morristown','Mount Arlington','Mount Laurel','Neptune','New Egypt','New Providence','Newark','North Bergen','Northfield','Northvale','Oak Ridge','Oakland','Old Bridge','Paramus','Park Ridge','Pennington','Pennsauken','Phillipsburg','Piscataway','Point Pleasant','Point Pleasant Beach','Rahway','Raritan','Red Bank','Ridgewood','Ringwood','Rio Grande','River Edge','Riverside','Riverton','Rochelle Park','Rumson','Saddle Brook','Seaside Heights','Secaucus','Sewell','Somerset','Somerville','South Plainfield','Sparta','Stanhope','Stirling','Succasunna','Summit','Toms River','Totowa','Trenton','Union','Verona','Vincentown','Vineland','Voorhees','Waldwick','Wall Township','Waretown','Wayne','West Berlin','West Long Branch','West Milford','West New York','West Orange','Westfield','Wharton','Wood Ridge','Woodbridge'],
            'NM': ['Albuquerque','Arroyo Hondo','Cedar Crest','Elephant Butt','Hatch','Las Cruces','Rio Rancho','Santa Fe','Santa Teresa','Sunland Park','Taos','Tesuque','Truth Or Consequences'],
            'NV': ['Las Vegas','Reno'],
            'NY': ['Albany','Albertson','Amagansett','Amherst','Armonk','Astoria','Babylon','Bayside','Bayville','Bedford Hills','Binghamton','Breezy Point','Briarcliff Manor','Bridgehampton','Bronx','Bronxville','Brooklyn','Buffalo','Carle Place','Carmel','Cobleskill','Commack','Cooperstown','Croton On Hudson','Deer Park','Dix Hills','Dobbs Ferry','East Atlantic Beach','East Meadow','East Norwich','Elmhurst','Elmira','Elmont','Elmsford','Farmingdale','Farmingville','Flushing','Forest Hills','Franklin Square','Garden City','Garden City Park','Glen Cove','Great Neck','Greenport','Greenville','Hampton Bays','Harrison','Hillsdale','Hopewell Junction','Huntington','Huntington Station','Island Park','Islip Ny','Jackson Heights','Jericho','Johnsonville','Katonah','Kingston','Lake Ronkonkoma','Larchmont','Little Falls','Liverpool','Long Beach','Long Island City','Manhasset','Marcellus','Massapequa','Mattituck','Merrick','Middle Village','Milton','Mohegan Lake','New Rochelle','New York','North Babylon','North Syracuse','North Tonawanda','Northport','Oakdale','Oceanside','Old Westbury','Oneonta','Oyster Bay','Ozone Park','Patchogue','Peekskill','Pelham','Point Lookout','Port Washington','Poughkeepsie','Pound Ridge','Prattsville','Queens','Queensbury','Ridgewood','Riverhead','Rochester','Rockaway Beach','Rome','Ronkonkoma','Roslyn Heights','Rye','Rye Ny','Rye Brook','Sayville','Setauket','Shelter Island Heights','Smithtown','South Salem','Southampton','Staten Island','Stewart Manor','Syosset','Syracuse','Tarrytown','Thornwood','Valatie','Wantagh','Wappingers Falls','Westbury','Westchester','Westhampton Beach','White Plains','Yonkers','Yorktown Heights'],
            'OK': ['Edmond','Norman','Oklahoma City','Pauls Valley','Purcell','Tulsa','Tuttle','Yukon'],
            'SC': ['Aiken','Charleston','Columbia','Easley','Florence','Fort Mill','Georgetown','Greenville','Greer','Hardeeville','Hilton Head Island','Irmo','Johns Island','Ladson','Landrum','Lexington','Little River','Mount Pleasant','Murrells Inlet','Myrtle Beach','North Charleston','Pendleton','Rock Hill','Simpsonville','Summerville','Walhalla','West Columbia'],
            'TX': ['Abilene','Addison','Allen','Angleton','Arlington','Atascocita','Austin','Azle','Bacliff','Bartonville','Bastrop','Beaumont','Bedford','Bee Cave','Beeville','Boerne','Brenham','Brownsville','Burleson','Carrizo Springs','Cedar Hill','Cedar Park','Clearlake','Coffee City','College Station','Colleyville','Conroe','Copperas Cove','Corpus Christi','Cypress','Dallas','Dalworthington Gardn','Decatur','Denton','Eagle Pass','Edinburg','El Paso','Elgin','Euless','Fate','Forest Hill','Fort Worth','Friendswood','Frisco','Gainesville','Galveston','Georgetown','Giddings','Graham','Granbury','Grand Prairie','Greenville','Harlingen','Hebron','Hickory Creek','Hockley','Houston','Hudson Oaks','Humble','Hurst','Irving','Jersey Village','Katy','Keller','Killeen','Kingwood','Kyle','Lake Dallas','Laredo','League City','Leander','Lewisville','Little Elm','Live Oak','Longview','Lubbock','Lumberton','Manor','Marble Falls','Marfa','Marshall','Mcallen','Mckinney','Midland','Mission','Missouri City','Mont Belvieu','Montgomery','Nacodgoches','Nacogdoches','New Braunfels','Odessa','Olmito','Pasadena','Pearland','Pinehurst','Plano','Port Aransas','Porter','Raymondville','Richardson','Richmond','Rio Hondo','Rockport','Rosenberg','Round Rock','Rowlett','Sachse','San Angelo','San Antonio','San Benito','San Marcos','Selma','Sherman','South Padre Island','Spring','Spring Valley','Stephenville','Sugarland','Sunset Valley','Temple','Terrell','Texas City','The Colony','The Woodlands','Tomball','Uvalde','Victoria','Webster','Weslaco','Westlake','Wichita Falls','Wimberley','Winona'],
            'WA': ['Arlington','Auburn','Bainbridge Island','Bellevue','Bothell','Bremerton','Burlington','Camas','Cheney','Clallam Bay','Cle Elum','Clinton','Eastsound','Edmonds','Everett','Federal Way','Freeland','Friday Harbor','Gig Harbor','Granite Falls','Issaquah','Kent','Kingston','Lacey','Lake Stevens','Lakewood','Langley','Lopez Island','Lynnwood','Marysville','Mercer Island','Mount Vernon','Mountlake Terrace','Mukilteo','North Bend','Oak Harbor','Olympia','Port Orchard','Port Townsend','Poulsbo','Pullman','Puyallup','Redmond','Renton','Richland','Rochester','Sammamish','Seattle','Shelton','Silverdale','Snoqualmie Pass','Spokane','Stanwood','Sumner','Tacoma','Vancouver','Yakima','Yelm'],
            'WI': ['Altoona','Appleton','Beloit','Cedarburg','Chippewa Falls','Delafield','Eagle River','Eau Claire','Elm Grove','Fremont','Green Bay','Hales Corners','Hartford','Hartland','Hillsboro','Hubertus','Jackson','Janesville','Kenosha','Kewaskum','Kohler','La Crosse','Lake Geneva','Land O Lakes','Madison','Mc Farland','Menomonee Falls','Middleton','Milwaukee','Minocqua','Necedah','Newburg','Oconomowoc','Okauchee','Onalaska','Oregon','Oshkosh','Pewaukee','Plover','Portage','Porterfield','Racine','Rhinelander','Richfield','Rockland','Shawano','Sheboygan','Sparta','Stevens Point','Stoughton','Sturgeon Bay','Sun Prairie','Superior','Tomah','Tomahawk','Verona','Viroqua','Waterford','Waukesha','Wausau','West Bend','Wisconsin Dells'],
          },
          cities: []
      };
    },


    beforeMount() {
      //console.log("Before")
     // dev https://us-central1-storelocatordb.cloudfunctions.net/parseJsonFile
      // prod https://us-central1-storelocatorapi-58f43.cloudfunctions.net/parseJsonFile
      axios.get('https://us-central1-storelocatorapi-58f43.cloudfunctions.net/parseJsonFile')
      //axios.get('https://us-central1-storelocatordb.cloudfunctions.net/parseJsonFile')
      .then(res => {
        const orderArray = res.data.sort((a, b) => {
          if (a.state !== b.state) {
            return a.state.localeCompare(b.state);
          }
          return a.city.localeCompare(b.city);
        });
       this.stores = orderArray;
      }).catch(err => {
        console.log(err.response);
      });
    },
    mounted() {
      //console.log("Getting Stores from NodeJS app")
      const autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("autocomplete"));
     autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      this.address = place.formatted_address;
      this.lat = place.geometry.location.lat();
      this.lng = place.geometry.location.lng();
    });

        if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          position => {
            this.lat = position.coords.latitude;
            this.lng = position.coords.longitude;

            this.getAddressFrom(
              position.coords.latitude,
              position.coords.longitude
            );

            if (this.stores==null)
            {
              this.stores=[]
            }

            if (this.stores!=[])
            {
            const orderArray = this.selectedType2.sort((a, b) => {
            const stateComparison = a.state.localeCompare(b.state);
            return stateComparison !== 0 ? stateComparison : a.city.localeCompare(b.city);
          });

            this.places = orderArray;
        }
            this.showPlacesOnMap()
          },
          error => {
              this.error = "Please either enable location services in your browser or manually enter the address below."
              console.log(error.message)
              this.spinner = false;
          });
        }
        else
        {
          console.log("Your browser does not support geolocation API")
        }

   //this.showPlacesOnMap()
   //this.locatorButtonPressed();
    },
    methods: {
      logClickedWebsite(website) {
        //this.logEventWebSite('Selected Website Store', website)
      },
      handleLinkClick(address)
      {
        this.logEvent('Clicked on the Map', address)
      },
      logEventWebSite(eventName,website) {

      const recLogger = []
      recLogger.push({
      timestamp: new Date().toISOString(),
      event: eventName,
      website: website
      }),
      this.sendLogsToServer(recLogger)
      },
      logEvent(eventName,address) {

        const addressArray = address.split(", ");

        const storeAddress = addressArray[0].replace(/,/g, '').trim() ;
        const city = addressArray[1];
        const stateZipcode = addressArray[2].split(" ");
        const state = stateZipcode[0];
        const zipcode = stateZipcode[1];
        const country = addressArray[3];

      const recLogger = []
      recLogger.push({
        timestamp: new Date().toISOString(),
        event: eventName,
        address: storeAddress,
        city: city,
        state: state,
        zipcode: zipcode
      }),
      this.sendLogsToServer(recLogger)
    },
      AdvlogEvent(eventName,data) {

      const storeTypeMatch = data.match(/Store Type: (.+?) City:/);
      const cityMatch = data.match(/City: (.+?) State:/);
      const stateMatch = data.match(/State: (.+)/);

      const storeType = storeTypeMatch ? storeTypeMatch[1].trim() : "";
      const city = cityMatch ? cityMatch[1].trim() : "";
      const state = stateMatch ? stateMatch[1].trim() : "";

      const recLogger = []
      recLogger.push({
        timestamp: new Date().toISOString(),
        event: eventName,
        storeType: storeType,
        city: city,
        state: state,
      }),


      this.sendLogsToServer(recLogger)
    },
     logEventCityState(eventName,data){

      const addressParts = data.split(', ');

      const city = addressParts[0];
      const state = addressParts[1];
      const country = addressParts[2];



      const recLogger = []
      recLogger.push({
        timestamp: new Date().toISOString(),
        event: eventName,
        city: city,
        state: state,
        country: country,
      })
      this.sendLogsToServer(recLogger)
      console.log("City/State logged")


      },
      logEventZipCode(eventName,data)
      {
      const regex = /^(.*),\s(.*?)\s(\d{5}),\s.*$/;
      const match = data.match(regex);
      const city = match[1];
      const state = match[2];
      const zipcode = match[3];

      console.log(city)
      console.log(state)
      console.log(zipcode)


      const recLogger = []
      recLogger.push({
        timestamp: new Date().toISOString(),
        event: eventName,
        city: city,
        state: state,
        zipcode: zipcode,
      })

      this.sendLogsToServer(recLogger)
      console.log("Zipcode saved")

    },
      menulogEvent(eventName,data) {

      console.log(data)

      const storeNameMatch = data.match(/Store Name: (.+?) Address:/);
      const addressMatch = data.match(/Address: (.+?) Zip:/);
      const zipMatch = data.match(/Zip:(.+?) City:/);
      const cityMatch = data.match(/City: (.+?) State:/);
      const stateMatch = data.match(/State: (.+)/);

      const storeName = storeNameMatch ? storeNameMatch[1].trim() : "";
      const address = addressMatch ? addressMatch[1].replace(/,/g, '').trim() : ""; // Remover vírgulas
      const zip = zipMatch ? zipMatch[1].trim() : "";
      const city = cityMatch ? cityMatch[1].trim() : "";
      const state = stateMatch ? stateMatch[1].trim() : "";


      const recLogger = []
      recLogger.push({
        timestamp: new Date().toISOString(),
        event: eventName,
        address: address,
        city: city,
        state: state,
        zipcode: zip,
        storeName: storeName
      }),
      this.sendLogsToServer(recLogger)
    },
    sendLogsToServer(recLogger) {
      console.log('logged')
      //console.log(recLogger)

      //axios.defaults.headers.post['Content-Type'] = 'application/json';
      axios
        .post("https://us-central1-storelocatorapi-58f43.cloudfunctions.net/logSL", recLogger)
        .then(() => {
          console.log("Log saved!");
          //this.eventsLog = [];
        })
        .catch((error) => {
          console.error("Error creating log file:", error);
        });
    },
      changeTab(index) {
          this.activeTab = index;
        },
        submitForm1() {
      //    console.log("FORM 1:", this.form1);
        },
        submitForm2() {
      //    console.log("FORM 2:", this.form2);
        },
      onEnter(e,address){
        e.preventDefault();
        this.toggleInput(e)
       // this.address = '';
       // console.log("Pressed Enter")
        this.showInput = !this.showInput;
        //console.log(this.lat)
        //console.log(this.lng)

        if (address.length > 1)

        {

        const regex = /,\s*([^,]+)\s*,/; // Regular expression to match text between commas
        const match = address.match(regex);

       // console.log(`address`)
       // console.log(address)


        const regexFullAddress = /^(.*), (.*), (.*?) (\d+),/; // Expressão regular para capturar endereço, cidade, estado e código postal

        const matchFullAddress = address.match(regexFullAddress);

        const addressPart = address.split(','); // Separa as partes pelo caractere vírgula

        console.log(addressPart)

        this.places = this.stores;

        this.selectedTypeMain = [];
        this.selectedTypeNear = [];
        this.selectedTypeRest = []

        if (addressPart.length==4)
        {
         console.log(`4 fields`)

          console.log(addressPart)
          const enderecoArray = address.split(", ");

          const rua = enderecoArray[0];
          const cidade = enderecoArray[1];
          const estadoZipcode = enderecoArray[2].split(" ");
          const estado = estadoZipcode[0];
          const zipcode = estadoZipcode[1];
          const pais = enderecoArray[3];

          console.log('Simple Search1')
          this.logEvent('Simple Search',address)
          console.log(address)

          for (let i=0; i< this.places.length; i++) {

          if (this.places[i].city.indexOf(cidade) !=-1)
            {

              this.selectedTypeMain.push(
            {
              "name": this.places[i].name,
              "address": this.places[i].address,
              "city": this.places[i].city,
              "state": this.places[i].state,
              "country": this.places[i].country,
              "url": this.places[i].url,
              "website": this.places[i].website,
              "type": this.places[i].type,
              "location": {
                "lat": this.places[i].location.lat,
                "lng": this.places[i].location.lng
              }
            }
            )
            }

            //console.log('Found BY CITY')

          }

          //this.selectedTypeMain.push(...this.selectedTypeNear)
          //this.selectedTypeMain.push(...this.selectedTypeRest)

          this.places = this.selectedTypeMain

         }
        else
        {

        console.log(addressPart.length)
          // Trying ZIPCODE
        const getCity = addressPart[0].trim();
        const getStateZipCode = addressPart[1].trim();
        const [getState, getZipcode] = getStateZipCode.split(' ');

        console.log('State:', getState);
        console.log('City:', getCity);
        console.log('Zipcode:', getZipcode);

        if (typeof getZipcode === 'undefined')
        {
          if (getState.indexOf('USA') !=-1)
          {
            console.log('Cannot get STATE')
          }
          else
          {
          console.log('Find CITY STATE')
          this.logEventCityState("Filter by City", address)
          }
        }
        else
        {
        console.log(address)
        this.logEventZipCode("Filter by Zip Code", address)
        //this.eventsLog("Search by Zipcode:",address)
        }

        this.places = this.stores;
        this.selectedTypeMain = [];
        this.selectedTypeNear = [];
        this.selectedTypeRest = []

        if (typeof getZipcode === 'undefined' && addressPart.length>3)
        {

          //console.log('Simple Search2')
          this.logEvent('Basic Search',address)
          // Orlando FL USA
          for (let i=0; i< this.places.length; i++) {

          if (this.places[i].city.indexOf(getCity) !=-1)
            {
            // console.log('found near zipcode')
              this.selectedTypeMain.push(
            {
              "name": this.places[i].name,
              "address": this.places[i].address,
              "city": this.places[i].city,
              "state": this.places[i].state,
              "country": this.places[i].country,
              "type": this.places[i].type,
              "url": this.places[i].url,
              "website": this.places[i].website,
              "location": {
                "lat": this.places[i].location.lat,
                "lng": this.places[i].location.lng
              }
            }
            )
            }

          }


        }


        else
        {
        for (let i=0; i< this.places.length; i++) {


          if (typeof getZipcode != 'undefined')
          {
              if (this.places[i].address.indexOf(`Zip:`+getZipcode) !=-1 || this.places[i].address.indexOf(`Zip:`+getZipcode.slice(0,-1)) !=-1 )
                {
                  this.selectedTypeMain.push(
                    {
                      "name": this.places[i].name,
                      "address": this.places[i].address,
                      "city": this.places[i].city,
                      "state": this.places[i].state,
                      "country": this.places[i].country,
                      "type": this.places[i].type,
                      "url": this.places[i].url,
                      "website": this.places[i].website,
                      "location": {
                        "lat": this.places[i].location.lat,
                        "lng": this.places[i].location.lng
                      }
                    })
                }
           }

            if (this.places[i].city.indexOf(getCity) !=-1)
            this.selectedTypeRest.push(
            {
              "name": this.places[i].name,
              "address": this.places[i].address,
              "city": this.places[i].city,
              "state": this.places[i].state,
              "country": this.places[i].country,
              "type": this.places[i].type,
              "url": this.places[i].url,
              "website": this.places[i].website,
              "location": {
                "lat": this.places[i].location.lat,
                "lng": this.places[i].location.lng
              }
             })

            }
      }
      this.selectedTypeMain.push(...this.selectedTypeNear)
      this.selectedTypeMain.push(...this.selectedTypeRest)

      this.places = this.selectedTypeMain

      //this.eventsLog("Simple Search - ZipCode", address)
     //this.logEvent("Simple Search3",address)

  }
}
else
{
// if click in search whitout text
  //console.log('Returning all stores')
  //this.logEvent('Simple Search','All Stores')
  this.places = this.stores;

}
    //console.log(this.selectedTypeMain)
    //console.log(this.selectedTypeSecondList)




     // if (this.places.length<1){
     //   this.places = this.stores;
      //}

        const map= new google.maps.Map(
        this.$refs["map"],
        {
          zoom:15,
          center: new google.maps.LatLng(this.lat,this.lng),
          mapTypeId: google.maps.MapTypeId.ROADMAP
        });
        const infoWindow = new google.maps.InfoWindow();

        this.markers = [];


        for (let i=0; i< this.places.length; i++) {


        if (this.places[i].type==="Bar/Restaurant")
        {
          this.icon[i] = require("@/assets/rabbit-pin-green.png");
        }
        else
        {
          this.icon[i] = require("@/assets/rabbit-pin-black.png");
        }

//        console.log("icon")
//        console.log(this.icon[i])


          const lat = this.places[i].location.lat;
          const lng = this.places[i].location.lng;
          const marker = new google.maps.Marker({
            position: new google.maps.LatLng(lat,lng),
            map: map,
           icon: {
              url: `${this.icon[i]}`,
                    scaledSize: new google.maps.Size(34, 34)
                },
          })

          this.markers.push(marker)


          google.maps.event.addListener(marker,"click", () => {
            infoWindow.setContent(
                `<div class="ui header">${this.places[i].name}</div>
                ${this.places[i].address} <br>
                ${this.places[i].city}&nbsp;-${this.places[i].state} &nbsp; ${this.places[i].type}  <br>
                <a href="${this.places[i].url}" target="_blank">View on Google Maps</a>
                `
              );
              infoWindow.open(map, marker);
         })
        }
      },
      toggleInput(e) {
        e.preventDefault();
        this.showInput = !this.showInput;
        //this.address = '';

      },
      clearList() {

        const orderArray = this.stores.sort((a, b) => {
            if (a.state < b.state) {
                return -1;
              } else if (a.state > b.state) {
                return 1;
              } else {
                  if (a.city < b.city) {
                    return -1;
                  } else if (a.city > b.city) {
                    return 1;
                  } else {
                    return 0;
                  }
              }
            });

            this.places = orderArray;


      },
      clearStates() {
        this.selectedState = '';
        this.selectedCity = '';
      },
      getCities() {
          this.cities = this.cityData[this.selectedState] || [];
          this.selectedCity = '';
      },
      getAddressFrom(lat, long) {
        axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng="
        +lat+','
        +long
        + "&key="+this.apiKey
        +"&callback=Function.prototype")
        .then(response => {
            if(response.data.error_message) {
              this.error = response.data.error;
              console.log(response.data.error_message)
        }
        else{
          this.address = (response.data.results[0].formatted_address)
         // console.log(response.data.results[0].formatted_address)
         // console.log("Selected Address")
          this.places = this.stores;
          this.showPlacesOnMap();

        }
        })
        .catch(error => {
          this.error = error.message;
          console.log(error.message)
          this.spinner = false;
        });
      },
      findCloseBuyButtonPressed(storeType,state,city,country,e) {
        e.preventDefault();


        //console.log(country)

        this.places = this.stores;

        this.selectedType2 = [];

        if (this.newChoice.type=="All")
        {
          storeType=""
        }

        if (this.country.type=="All")
        {
          country=""
        }

        if (this.state.type=="All states")
        {
          state=""
        }

        if (this.state.type=="Select a city")
        {
          city=""
        }

        if ((country=="All") || (country=="Italy") || (country=="Monaco") || (country=="England") || (country=="United Arab Emirates"))
        {
          city=""
          state=""
        //  console.log(country)
        }

    const logAdv = "Store Type: " + this.newChoice.type + " City: "+ city + " State: " + state

    this.AdvlogEvent('Advanced Search',logAdv)


        for (let i=0; i< this.places.length; i++) {
// NOT ALL STORES
          if ((this.places[i].type.indexOf(storeType) !=-1)
            && (this.places[i].country.indexOf(country) !=-1)
              && (this.places[i].state.indexOf(state) !=-1)
                && (this.places[i].city.indexOf(city) !=-1))
            {
            this.selectedType2.push(
            {
              "name": this.places[i].name,
              "address": this.places[i].address,
              "city": this.places[i].city,
              "state": this.places[i].state,
              "country": this.places[i].country,
              "type": this.places[i].type,
              "url": this.places[i].url,
              "website": this.places[i].website,
              "location": {
                "lat": this.places[i].location.lat,
                "lng": this.places[i].location.lng
              }
             }
            )
            }
      }

      const orderArray = this.selectedType2.sort((a, b) => {
      const stateComparison = a.state.localeCompare(b.state);
      return stateComparison !== 0 ? stateComparison : a.city.localeCompare(b.city);
    });

      this.places = orderArray;


      //this.places =this.selectedType2
      this.showPlacesOnMap()
     },

     showPlacesOnMap() {
  const map = new google.maps.Map(
    this.$refs["map"],
    {
      zoom: 15,
      center: new google.maps.LatLng(this.lat, this.lng),
      mapTypeId: google.maps.MapTypeId.ROADMAP
    }
  );
  const infoWindow = new google.maps.InfoWindow();
  this.markers = [];

  // Mapeamento de ícones pré-definidos
  const iconMapping = {
    "Bar/Restaurant": require("@/assets/rabbit-pin-green.png"),
    // Outros tipos aqui
  };

  this.places.forEach((place) => {
    const latLng = new google.maps.LatLng(place.location.lat, place.location.lng);
    const marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: {
        url: iconMapping[place.type] || require("@/assets/rabbit-pin-black.png"),
        scaledSize: new google.maps.Size(34, 34)
      }
    });

    this.markers.push(marker);

    google.maps.event.addListener(marker, "click", () => {
      infoWindow.setContent(
        `<div class="ui header">${place.name}</div>
         ${place.address} <br>
         ${place.city}&nbsp;-${place.state} &nbsp; ${place.type}  <br>
         <a href="${place.url}" target="_blank">View on Google Maps</a>`
      );
      infoWindow.open(map, marker);
    });
  });
},

    showInfoWindow(index) {
      this.activeIndex = index;
      new google.maps.event.trigger(this.markers[index],"click")

      const logMenu = "Store Name: " + this.places[index].name + " Address: "+ this.places[index].address + " City: " + this.places[index].city + " State: " + this.places[index].state
      this.menulogEvent('Choose Store from Menu',logMenu)


    }
  },
    showUserLocationOnTheMap(latitude, longitude) {
    const userLocation = new google.maps.LatLng(latitude, longitude);

    const map = new google.maps.Map(document.getElementById("map"), {
      zoom: 15,
      center: userLocation,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    });

    const marker = new google.maps.Marker({
      position: userLocation,
      map: map
    });

    const infoWindow = new google.maps.InfoWindow();
    infoWindow.open(map, marker);
  },
  };
  </script>

<style>

  @import url('https://fonts.googleapis.com/css2?family=Cabin&display=swap');

  * {
    font-family: 'Cabin', sans-serif;
  }

  body {
    background-color: #222;
  }

  #result-title p {
    margin: 16px 0 4px 0;
    font-size: 14px;
  }

  #store-list {
    height: auto;
    max-height: 300px;
    overflow: auto;
    margin-top: 0;
  }

  #map-container {
    min-height: 520px;
    background-color: #333;
  }

  label,
  p,
  .ui.list>.item .header  {
    color: #fff !important;
    font-size: 16px;
    margin-bottom: 4px;
  }

  .ui.list>.item .description {
    color: #bbb;
  }

  .description-link {
    padding: 8px 24px;
    margin-top: 8px;
    display: table;
    border-radius: 4px;
    background-color: #7a7d7e;
    color: #fff !important;
    font-size: 14px !important;
  }

  .description-link:hover {
    background-color: #999;
  }

  .ui.list>.item {
    cursor: pointer;
  }

  .ui.list>.item:hover {
    background-color: #444;
  }

  .ui.divided.list>.item {
    border-color: #505050;
  }

  .ui.button,
  .dot.circle.icon {
    background-color: #00594e;
    color: #f5deda;
    text-transform: uppercase;
    font-size: 16px !important;
  }

  .ui.button:hover,
  .ui.button:active {
    background-color: #19695f;
    color: #fff;
  }

  .ui.segment {
    border: 1px solid #565454;
    background-color: #333;
  }

  .pac-icon {
    display:none;
  }

  .pac-item {
    padding: 10px;
    font-size: 16px;
    cursor: pointer;
  }

  .pac-item:hover {
    background-color: #ececec;
  }

  .pac-item-query {
    font-size: 16px;
  }
  .active {
    background: #19695f !important;
  }

  .tab-menu {
    display: flex;
    margin-bottom: -1px;
  }

  .tab-menu button {
    padding: 8px 16px;
    border: 1px solid #525252;
    background: #222;
    color: #ccc !important;
    cursor: pointer;
    border-radius: 8px 8px 0 0;
    font-family: 'Cabin', sans-serif;
  }

  .tab-menu button.active {
    background-color: #333 !important;
    color: #fff !important;
    border-bottom: none;
  }

  .tab-content {
    padding: 16px;
    border-radius: 0 0 8px 8px;
    border: 1px solid #565454;
    background: #333;
  }

  .tab-content > div:first-child {
    display: block;
  }

  .ui.red.message {
    background-color: #331801;
    border-color: #bd5500;
    color: #fff;
    padding: 8px;
  }

  #map-caption {
    display: table;
    width: 100%;
    text-align: center;;
    padding: 8px;
    background: #333;
    border-radius: 4px 4px 0 0;
  }

  #map-caption small {
    font-size: 12px;
    color: #ccc;
  }

  #map-caption small:nth-child(2) {
    margin-right: 32px;
  }

  .caption-color {
    display: inline-block;
    border: 1px solid #000;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    margin-right: 4px;
  }

  #availability-alert {
    text-align: center;
    padding: 8px;
    border: 1px solid #333;
    color: #f5deda;
    border-radius: 0px 0px 4px 4px;
  }

  @media screen and (max-width:767px) {
    #store-list {
      max-height: 250px;
    }
    #map-caption {
      display: block;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/CloseBuy.vue